import { useState, useEffect } from "react";


const useScreenWidth = () => {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1380);

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1380);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isWideScreen;
};

export default useScreenWidth;
